import listViewStore from '../store/Store';
import getTableConversationRelation from '../utils/getTableConversationRelation';
import getTableItemRelation from '../utils/getTableItemRelation';
import isItemOfMessageType from '../utils/isItemOfMessageType';
import * as pinningUtils from '../utils/pinningUtils';
import { mailStore } from 'owa-mail-store';
import { trace } from 'owa-trace';
var MailRowDataPropertyType;
(function (MailRowDataPropertyType) {
    MailRowDataPropertyType[MailRowDataPropertyType["CanDelete"] = 0] = "CanDelete";
    MailRowDataPropertyType[MailRowDataPropertyType["Categories"] = 1] = "Categories";
    MailRowDataPropertyType[MailRowDataPropertyType["ConversationId"] = 2] = "ConversationId";
    MailRowDataPropertyType[MailRowDataPropertyType["EffectiveMentioned"] = 3] = "EffectiveMentioned";
    MailRowDataPropertyType[MailRowDataPropertyType["ExecuteSearchSortOrder"] = 4] = "ExecuteSearchSortOrder";
    MailRowDataPropertyType[MailRowDataPropertyType["FlagStatus"] = 5] = "FlagStatus";
    MailRowDataPropertyType[MailRowDataPropertyType["InstrumentationContext"] = 6] = "InstrumentationContext";
    MailRowDataPropertyType[MailRowDataPropertyType["IsDraft"] = 7] = "IsDraft";
    MailRowDataPropertyType[MailRowDataPropertyType["IsPinned"] = 8] = "IsPinned";
    MailRowDataPropertyType[MailRowDataPropertyType["IsSubmitted"] = 9] = "IsSubmitted";
    MailRowDataPropertyType[MailRowDataPropertyType["ItemIds"] = 10] = "ItemIds";
    MailRowDataPropertyType[MailRowDataPropertyType["LastDeliveryOrRenewTimeStamp"] = 11] = "LastDeliveryOrRenewTimeStamp";
    MailRowDataPropertyType[MailRowDataPropertyType["LastDeliveryTimeStamp"] = 12] = "LastDeliveryTimeStamp";
    MailRowDataPropertyType[MailRowDataPropertyType["LastModifiedTimeStamp"] = 13] = "LastModifiedTimeStamp";
    MailRowDataPropertyType[MailRowDataPropertyType["LastSenderMailbox"] = 14] = "LastSenderMailbox";
    MailRowDataPropertyType[MailRowDataPropertyType["LastSenderSMTP"] = 15] = "LastSenderSMTP";
    MailRowDataPropertyType[MailRowDataPropertyType["ParentFolderId"] = 16] = "ParentFolderId";
    MailRowDataPropertyType[MailRowDataPropertyType["RowClientItemId"] = 17] = "RowClientItemId";
    MailRowDataPropertyType[MailRowDataPropertyType["RowIdString"] = 18] = "RowIdString";
    MailRowDataPropertyType[MailRowDataPropertyType["Size"] = 19] = "Size";
    MailRowDataPropertyType[MailRowDataPropertyType["Subject"] = 20] = "Subject";
    MailRowDataPropertyType[MailRowDataPropertyType["UniqueSenders"] = 21] = "UniqueSenders";
    MailRowDataPropertyType[MailRowDataPropertyType["UnreadCount"] = 22] = "UnreadCount";
    MailRowDataPropertyType[MailRowDataPropertyType["ValidCouponIndexes"] = 23] = "ValidCouponIndexes";
})(MailRowDataPropertyType || (MailRowDataPropertyType = {}));
/**
 * Get canDelete for a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return boolean for canDelete
 */
export function getCanDelete(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.CanDelete);
}
/**
 * Get categories for a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return a collection of categories
 */
export function getCategories(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.Categories);
}
/**
 * Get conversation id for a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return a collection of categories
 */
export function getConversationId(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.ConversationId);
}
/**
 * Get if a row is pinned
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return true if a row is pinned, false otherwise
 */
export function getIsPinned(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.IsPinned);
}
/**
 * Get the itemIds
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return itemIds if row is Conversation, or itemId if row is Item
 */
export function getItemIds(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.ItemIds);
}
/**
 * Get the executeSearchSortOrder of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the executeSearchSortOrder
 */
export function getExecuteSearchSortOrder(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.ExecuteSearchSortOrder);
}
/**
 * Get the getUniqueSenders of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the getUniqueSenders
 */
export function getUniqueSenders(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.UniqueSenders);
}
/**
 * Get the flag status of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the flag status
 */
export function getFlagStatus(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.FlagStatus);
}
/**
 * Get the effective mentioned of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return whether there is a mention
 */
export function getEffectiveMentioned(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.EffectiveMentioned);
}
/**
 * Get the lastDeliveryOrRenewTimeStamp of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the lastDeliveryOrRenewTimeStamp
 */
export function getLastDeliveryOrRenewTimeStamp(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.LastDeliveryOrRenewTimeStamp);
}
/**
 * Get the lastModifiedTimeStamp of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the lastDeliveryOrRenewTimeStamp
 */
export function getLastModifiedTimeStamp(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.LastModifiedTimeStamp);
}
/**
 * Get the lastDeliveryTimeStamp of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the lastDeliveryTimeStamp
 */
export function getLastDeliveryTimeStamp(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.LastDeliveryTimeStamp);
}
/**
 * Get the subject of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the subject
 */
export function getSubject(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.Subject);
}
/**
 * Get the last sender mailbox of a row
 * @param rowKey key of the row data
 * @param tableView the table that contains the row data
 * @return the last sender mailbox of a row
 */
export function getLastSenderMailbox(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.LastSenderMailbox);
}
/**
 * Get the last sender smtp address of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the last sender smtp address of a row
 */
export function getLastSenderSMTP(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.LastSenderSMTP);
}
/**
 * Get the unread count of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the unread count
 */
export function getUnreadCount(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.UnreadCount);
}
/**
 * Get the size of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the unread count
 */
export function getSize(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.Size);
}
/**
 * Get the string type rowId of the row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the row id string
 */
export function getRowIdString(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.RowIdString);
}
/**
 * Get the ClientItemId type rowId of the row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the row client id
 */
export function getRowClientItemId(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.RowClientItemId);
}
/**
 * Get the source folder id of the row data
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the source folder id
 */
export function getParentFolderId(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.ParentFolderId);
}
/**
 * Get the size of a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return the 3S search result instrumentation context
 */
export function getInstrumentationContext(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.InstrumentationContext);
}
/**
 * Get if an item is a draft
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return true if an item is a draft, false otherwise
 */
export var getIsDraft = function getIsDraft(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.IsDraft);
};
/**
 * Get if an item is submitted
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return true if an item is submitted, false otherwise
 */
export var getIsSubmitted = function getIsSubmitted(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.IsSubmitted);
};
/**
 * Get valid coupon indexes for a row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @return indexes of valid coupons
 */
export function getValidCouponIndexes(rowKey, tableView) {
    return getRowDataProperty(rowKey, tableView, MailRowDataPropertyType.ValidCouponIndexes);
}
/**
 * Get the specified property from the row
 * @param rowKey rowKey of row
 * @param tableView the table that contains the row data
 * @param propertyType to retrieve on the row data
 */
function getRowDataProperty(rowKey, tableView, propertyType) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            return getConversationProperty(rowKey, tableView, propertyType);
        case 1 /* Message */:
            return getItemProperty(rowKey, tableView, propertyType);
        default:
            return null;
    }
}
/**
 * Get the specified property on the item
 * @param conversationRowKey the rowKey of the conversation
 *  @param tableView the table that contains the row data
 * @param propertyType the MailRowDataPropertyType
 * @return the specified property on the conversation
 */
function getConversationProperty(conversationRowKey, tableView, propertyType) {
    var tableConversationRelation = getTableConversationRelation(conversationRowKey, tableView.id);
    if (!tableConversationRelation) {
        trace.error('getConversationProperty should not be called on conversation that not in cache.');
        return null;
    }
    var conversationId = tableConversationRelation.id;
    var conversationItem = listViewStore.conversationItems.get(conversationId);
    var conversationItemParts = mailStore.conversations.get(conversationId);
    switch (propertyType) {
        case MailRowDataPropertyType.RowIdString:
            return tableConversationRelation.id;
        case MailRowDataPropertyType.RowClientItemId:
            return conversationItem.clientId;
        case MailRowDataPropertyType.ConversationId:
            return conversationId;
        case MailRowDataPropertyType.FlagStatus:
            return tableConversationRelation.flagStatus;
        case MailRowDataPropertyType.IsPinned:
            return pinningUtils.getIsTableConversationRelationPinned(tableConversationRelation);
        case MailRowDataPropertyType.ItemIds:
            return tableConversationRelation.itemIds;
        case MailRowDataPropertyType.LastDeliveryOrRenewTimeStamp:
            return tableConversationRelation.lastDeliveryOrRenewTimeStamp;
        case MailRowDataPropertyType.LastDeliveryTimeStamp:
            return tableConversationRelation.lastDeliveryTimeStamp;
        case MailRowDataPropertyType.LastModifiedTimeStamp:
            return tableConversationRelation.lastModifiedTimeStamp;
        case MailRowDataPropertyType.UnreadCount:
            return tableConversationRelation.unreadCount;
        case MailRowDataPropertyType.LastSenderMailbox:
            return (tableConversationRelation.lastSender && tableConversationRelation.lastSender.Mailbox // lastSender is undefined in rowModified notification payload, if the message is directly POSTed
            );
        case MailRowDataPropertyType.LastSenderSMTP:
            return (tableConversationRelation.lastSender && // lastSender is undefined in rowModified notification payload, if the message is directly POSTed
                tableConversationRelation.lastSender.Mailbox.EmailAddress);
        case MailRowDataPropertyType.ExecuteSearchSortOrder:
            return tableConversationRelation.executeSearchSortOrder;
        case MailRowDataPropertyType.ParentFolderId:
            if (tableView.tableQuery.type === 1 /* Search */) {
                return tableConversationRelation.parentFolderId;
            }
            else {
                // Use tableView.tableQuery.folderId for non-search scenarios, because parentFolderId is not returned for findConversation
                return tableView.tableQuery.folderId;
            }
        case MailRowDataPropertyType.Subject:
            return conversationItem.subject;
        case MailRowDataPropertyType.UniqueSenders:
            return tableConversationRelation.uniqueSenders;
        case MailRowDataPropertyType.Size:
            return conversationItem.size;
        case MailRowDataPropertyType.EffectiveMentioned:
            return tableConversationRelation.effectiveMentioned;
        case MailRowDataPropertyType.InstrumentationContext:
            return tableConversationRelation.instrumentationContext;
        case MailRowDataPropertyType.Categories:
            return tableConversationRelation.categories;
        case MailRowDataPropertyType.CanDelete:
            return conversationItemParts && conversationItemParts.canDelete;
        case MailRowDataPropertyType.ValidCouponIndexes:
            return conversationItem.validCouponIndexes;
        case MailRowDataPropertyType.IsSubmitted:
        case MailRowDataPropertyType.IsDraft:
        default:
            return null;
    }
}
/**
 * Get the specified property on the item
 * @param itemRowKey the rowKey for the item
 * @param tableView the table that contains the row data
 * @param propertyType the MailRowDataPropertyType
 * @return the specified property on the item
 */
function getItemProperty(itemRowKey, tableView, propertyType) {
    var itemRelation = getTableItemRelation(itemRowKey, tableView.id);
    if (!itemRelation) {
        trace.error('getRowDataProperty should not be called on item that not in item relations.');
        return null;
    }
    var itemId = itemRelation.clientId;
    var item = mailStore.items.get(itemId.Id);
    if (!item) {
        trace.error('getItemProperty should not be called on item that not in item cache.');
        return null;
    }
    var message = isItemOfMessageType(item) ? item : null;
    var lastSenderMailBox = message && message.From && message.From.Mailbox;
    switch (propertyType) {
        case MailRowDataPropertyType.RowIdString:
            return itemId.Id;
        case MailRowDataPropertyType.RowClientItemId:
            //TODO: 22724 we need to use our own item type which has clientItemId instead of retrieving from tableItemRelation
            return itemId;
        case MailRowDataPropertyType.ConversationId:
            return message.ConversationId.Id;
        case MailRowDataPropertyType.FlagStatus:
            // item.Flag could be undefined in search results
            return item.Flag ? item.Flag.FlagStatus : null;
        case MailRowDataPropertyType.IsPinned:
            return pinningUtils.getIsTableItemDataPinned(item);
        case MailRowDataPropertyType.ItemIds:
            return [itemId.Id];
        case MailRowDataPropertyType.LastDeliveryOrRenewTimeStamp:
            return item.ReceivedOrRenewTime;
        case MailRowDataPropertyType.LastDeliveryTimeStamp:
            return item.DateTimeReceived;
        case MailRowDataPropertyType.LastModifiedTimeStamp:
            return item.LastModifiedTime;
        case MailRowDataPropertyType.UnreadCount:
            // returns 1 if message exists and it's unread
            // returns 0 if message is read, or item is not Message type
            return message && !message.IsRead ? 1 : 0;
        case MailRowDataPropertyType.LastSenderMailbox:
            return lastSenderMailBox;
        case MailRowDataPropertyType.LastSenderSMTP:
            return lastSenderMailBox && lastSenderMailBox.EmailAddress;
        case MailRowDataPropertyType.UniqueSenders:
            if (lastSenderMailBox) {
                return [lastSenderMailBox.Name];
            }
            return null;
        case MailRowDataPropertyType.ExecuteSearchSortOrder:
            // The SortOrderSource depends on each search table, so it should be accessed from item relation
            return itemRelation.executeSearchSortOrder;
        case MailRowDataPropertyType.ParentFolderId:
            return item.ParentFolderId.Id;
        case MailRowDataPropertyType.Subject:
            return item.Subject;
        case MailRowDataPropertyType.Size:
            return item.Size;
        case MailRowDataPropertyType.EffectiveMentioned:
            return item.MentionedMe;
        case MailRowDataPropertyType.IsDraft:
            return item.IsDraft;
        case MailRowDataPropertyType.IsSubmitted:
            return item.IsSubmitted;
        case MailRowDataPropertyType.InstrumentationContext:
            return itemRelation.instrumentationContext;
        case MailRowDataPropertyType.Categories:
            return item.Categories;
        case MailRowDataPropertyType.CanDelete:
            return item.CanDelete;
        case MailRowDataPropertyType.ValidCouponIndexes:
            return item.validCouponIndexes;
        default:
            return null;
    }
}
//# sourceMappingURL=mailRowDataPropertyGetter.js.map